import * as React from "react";
const SvgWechatpay = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 26"
    {...props}
  >
    <path fill="#1AAD19" d="M0 0h40v26H0z" />
    <path fill="#1AAD19" d="M0 0h40v26H0z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M17.547 15.12a.6.6 0 0 1-.793-.244l-.04-.086-1.638-3.622a.301.301 0 0 1 .45-.37l1.934 1.387a.89.89 0 0 0 .799.092L27.352 8.2C25.722 6.265 23.038 5 20 5c-4.97 0-9 3.383-9 7.556 0 2.277 1.212 4.326 3.11 5.712a.605.605 0 0 1 .22.685l-.406 1.524c-.018.072-.048.146-.048.22a.3.3 0 0 0 .3.303.34.34 0 0 0 .174-.056l1.97-1.146a.94.94 0 0 1 .478-.14q.138.001.264.04c.92.267 1.911.415 2.938.415 4.97 0 9-3.384 9-7.557a6.6 6.6 0 0 0-1.025-3.501l-10.363 6.028z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgWechatpay;
